"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import type { OrganizationRanking } from "@/entities/organization/api/organizations";
import type { PaginatedResponse } from "@/shared/api/common";
import { CtaSection } from "@/widgets/landing/ui/cta-section";
import { FeaturesSection } from "@/widgets/landing/ui/features-section";
import { HeroSection } from "@/widgets/landing/ui/hero-section";
import { HowItWorksSection } from "@/widgets/landing/ui/how-it-works-section";
import { LandingFooter } from "@/widgets/landing/ui/landing-footer";
import { LandingHeader } from "@/widgets/landing/ui/landing-header";
import { LazySection } from "@/widgets/landing/ui/lazy-section";
import { ProblemSection } from "@/widgets/landing/ui/problem-section";
import { RatingsSection } from "@/widgets/landing/ui/ratings-section";
const ShowcaseSection = dynamic(() => import("@/widgets/landing/ui/showcase-section").then(m => m.ShowcaseSection), {
  ssr: false
});
const DataSections = dynamic(() => import("@/widgets/landing/ui/data-sections").then(m => m.DataSections), {
  ssr: false
});
export function LandingPageClient(t0) {
  const $ = _c(15);
  const {
    rankings
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LandingHeader />;
    t2 = <HeroSection />;
    t3 = <ProblemSection />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LazySection minHeight="600px"><ShowcaseSection /></LazySection>;
    t5 = <HowItWorksSection />;
    t6 = <FeaturesSection />;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== rankings) {
    t7 = <RatingsSection initialData={rankings} />;
    $[6] = rankings;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <LazySection minHeight="400px"><DataSections /></LazySection>;
    t9 = <CtaSection />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7) {
    t10 = <main>{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}</main>;
    $[10] = t7;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <LandingFooter />;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t10) {
    t12 = <div className="relative min-h-screen scroll-smooth bg-white text-slate-900 antialiased">{t1}{t10}{t11}</div>;
    $[13] = t10;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  return t12;
}